import React from "react";

const Contact: React.FC = () => {
  return (
    <div id="contact" className="p60">
      <div className="container">
        <h3>Contact</h3>
        <div className="row">
          <div className="col-md-4">
            <h5>Lekki</h5>
            <ul>
              {/* <li> */}
              {/*   <i className="fas fa-map-marker-alt"></i> */}
              {/*   1st Floor, 10Bou Plaza, Beside Global International School. */}
              {/*   Admiralty way, Lekki, Lagos, Nigeria. */}
              {/* </li> */}
              <li>
                <i className="fas fa-phone"></i>
                +234 813 035 3388
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@stemcafe.io">info@stemcafe.io</a>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <h5>Yaba</h5>
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i>
                3rd Floor, 8 Montgomery Road, Sabo Yaba
              </li>
              <li>WhatsApp +2348130353388</li>
              <li>
                <i className="fas fa-phone"></i>
                +2348130353388
              </li>

              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@stemcafe.io">info@stemcafe.io</a>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <h5>Port Harcourt</h5>
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i>
                26 Isiokpo Street, D-Line, Port Harcourt
              </li>
              <li>
                <i className="fas fa-phone"></i>
                +2347072975490
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@stemcafe.io">info@stemcafe.io</a>
              </li>
            </ul>
          </div>
          <div className="col-md-4" style={{ marginTop: "20px" }}>
            <h5>Kigali</h5>
            <p>
              <i className="fas fa-phone"></i>
              +250790137616
            </p>
            <br />
            <h5>Nairobi</h5>
            <p>
              <i className="fas fa-phone"></i>
              +254742588154
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
